/**
* @Author: ssdacs
* @Description: 格式化myNumber输入框
* @date: 2021/07/23
* @time:16:13
*/
<template>
  <div class="cNumInput-container">
    <input
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="number"
      :class="{ error: formatError, inputEdited: number }"
      autocomplete="off"
      pattern="[0-9]*"
      maxlength="14"
      oninput="value = value.replace(/[^\d０-９]/g, ''); if (value.length > 12) value = value.slice(0, 12)"
      @blur="handleblur"
      @focus="handleComposing"
    />
    <p v-if="formatError && message" class="inputMessage" v-html="$sanitize(message)"></p>
  </div>
</template>

<script>
    export default {
      name: 'cFormatNumInput',
      props: [
        'value',
        'placeholder', //提示信息
        'message', //错误信息
        'formatError',
        'disabled'
      ],
      data(){
        return{
          number:''
        }
      },
      created() {
        this.number=this.value
      },
      watch:{
        value(newV){
          this.number=newV
        },
        number(newVal,oldVal){
          let numArr=newVal.toString().split('').filter((s)=>{ return s&&s.trim()})
          let newNumArr=[]
          let len=numArr.length-1;
          numArr.forEach((e,k)=>{
           let  pattern = /[０-９0-9]/
            if( k<12 && pattern.test(e)){
              newNumArr.push(e)
              if((k==3 || k==7) && len > k){
                newNumArr.push('　')
              }
            }
          })
          this.number=newNumArr.join('')
          this.$emit('input', newNumArr.join(''))
        }
      },
      methods: {
        handleInput($event){
        },
        //正在输入
        handleComposing() {
          this.$emit('update:formatError', false);
        },
        // 失去焦点，校验信息
        handleblur() {
          this.$emit('blur');
          if(this.number){
            if(this.commonJs.ToCDB(this.number)){
              this.number=this.commonJs.ToCDB(this.number);
            }
          }
        }
      }
    }
</script>

<style scoped lang="less">
  .cNumInput-container {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    position: relative;
    input {
      height: 0.5rem;
      background: var(--bg-pinkcolor);
      border: 2px solid var(--maincolor);
      font-size: 0.16rem;
      line-height: 0.5rem;
      color: var(--text-graycolor);
      padding: 0 0.14rem;
      width: 100%;
      border-radius: 5px;
    }
    .inputEdited {
      background-color: #ffffff;
      color: #333333;
    }
    .error {
      border: 1px solid red;
    }
    .inputMessage {
      padding: 0 0.05rem;
      color: red;
      font-size: 0.12rem;
      line-height: 0.14rem;
      min-height: 0.28rem;
      white-space: pre-wrap;
      margin-top: 0.05rem;
      position: absolute;
      top: 0.5rem;
    }
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Input/cFormatNumInput.vue